// @ts-nocheck
// Shopify pricing calculator widget for the `insights/shopify-pricing` article.
//
// Rate data comes from assets/tool-shopify-plans.js (window.SheroPlans), which is the
// only place plan prices and card rates live in this theme. This file used to carry its
// own copy of the table and had drifted: it quoted 2.6% for Grow and 2.4% for Advanced
// against the maintained 2.7% and 2.5%.
//
// snippets/blog-scripts.liquid must register tool-shopify-plans.js before this file;
// `defer` preserves document order.
(function () {
  // No local rate table on purpose. If the shared one has not loaded, leave the widget
  // inert showing em-dashes rather than compute with numbers we cannot vouch for.
  var P = window.SheroPlans;
  if (!P) return;

  // calcResult returns null totals when revenue or AOV is missing, so both formatters
  // have to survive that even though the caller guards the empty case first.
  function fmt(n) {
    if (n == null || !isFinite(n)) return '—';
    return '$' + n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function fmtInt(n) {
    if (n == null || !isFinite(n)) return '—';
    return n.toLocaleString('en-US');
  }

  // Guarded against doubling: if the article markup ever gains its own hardcoded
  // <option> list, appending the same set here again would duplicate every entry.
  function populateSelects(planEl, revenueEl) {
    if (!planEl.options.length) {
      P.PLAN_KEYS.forEach(function (key) {
        var opt = document.createElement('option');
        opt.value = key;
        opt.textContent = P.PLANS[key].name;
        planEl.appendChild(opt);
      });
    }

    if (!revenueEl.options.length) {
      var opt0 = document.createElement('option');
      opt0.value = '';
      opt0.textContent = 'Select revenue';
      revenueEl.appendChild(opt0);

      P.REVENUE_TIERS.forEach(function (tier) {
        var opt = document.createElement('option');
        opt.value = String(tier);
        opt.textContent = '$' + tier.toLocaleString('en-US');
        revenueEl.appendChild(opt);
      });

      var optOther = document.createElement('option');
      optOther.value = 'other';
      optOther.textContent = 'Other (Enter custom value)';
      revenueEl.appendChild(optOther);
    }
  }

  // The article body is authored in the Shopify admin, not in this repo, so the custom
  // field's id cannot be verified from here: the snippet uses `spc-custom-revenue` and
  // this file used to look only for `custom-revenue`, leaving the custom-revenue path
  // dead if the article used the other spelling. Accept either rather than guess.
  function customField() {
    return (
      document.getElementById('spc-custom-revenue') || document.getElementById('custom-revenue')
    );
  }

  function calculate() {
    var planKey = document.getElementById('spc-plan').value;
    var revenueEl = document.getElementById('spc-revenue');
    var aovEl = document.getElementById('spc-aov');
    var customEl = customField();

    var revenue =
      revenueEl.value === 'other'
        ? (customEl && parseFloat(customEl.value)) || 0
        : parseFloat(revenueEl.value) || 0;

    var aov = parseFloat(aovEl.value) || 0;

    var ordersEl = document.getElementById('spc-orders');
    var txEl = document.getElementById('spc-tx');
    var totalEl = document.getElementById('spc-total');
    var footEl = document.getElementById('spc-foot');

    // Both the footnote and the maths now come from the shared table.
    var footnote = P.planFootnote(planKey, 'monthly');

    var input = { plan: planKey, revenue: revenue, aov: aov, period: 'monthly' };

    if (!revenue || !aov) {
      ordersEl.textContent = '—';
      txEl.textContent = '—';
      totalEl.textContent = '—';
      footEl.textContent = footnote;
      // Clears rather than skips: returning early here left the previous
      // recommendation on screen after the shopper emptied the AOV field.
      renderRecommendation(input, footEl);
      return;
    }

    var result = P.calcResult(input);

    ordersEl.textContent = fmtInt(result.orders);
    txEl.textContent = fmt(result.txFees);
    totalEl.textContent = fmt(result.total);
    footEl.textContent = footnote;

    renderRecommendation(input, footEl);
  }

  /*
   * The article asks "which plan should you choose", so the widget has to answer it
   * rather than only price the plan already selected. It carries none of the eligibility
   * inputs the full tool has, so this is the cost answer alone, and above
   * INDICATIVE_REVENUE it says so instead of presenting a total as a decision.
   *
   * The slot is created once and reused. The article body may or may not already contain
   * one, so an existing [data-spc-rec] always wins: building DOM unconditionally is how
   * this widget doubled its dropdowns once before.
   */
  function renderRecommendation(input, afterEl) {
    var rec = P.recommendPlan(input);
    var slot = document.querySelector('[data-spc-rec]');

    if (!slot) {
      if (!afterEl || !afterEl.parentNode) return;
      slot = document.createElement('p');
      slot.setAttribute('data-spc-rec', '');
      afterEl.parentNode.insertBefore(slot, afterEl.nextSibling);
    }

    if (!rec.hasInputs || !rec.cheapestEligible) {
      slot.textContent = '';
      return;
    }

    var name = P.PLANS[rec.cheapestEligible].name;
    slot.textContent = rec.indicative
      ? name +
        ' is the cheapest of the four plans at these numbers, but at your volume that is' +
        ' not the whole decision: staff seats, extra storefronts and checkout customization' +
        ' decide it long before the processing gap does.'
      : name + ' has the lowest total cost at these numbers.';
  }

  function onRevenueChange() {
    var input = customField();
    var show = document.getElementById('spc-revenue').value === 'other';
    if (input) {
      input.style.display = show ? 'block' : 'none';
      if (!show) input.value = '';
    }
    calculate();
  }

  function init() {
    // The full calculator (snippets/tool-shopify-pricing.liquid) uses the same field ids.
    // When an article embeds it, that tool's own script runs it and this one stays out.
    if (document.querySelector('[data-tool="shopify_pricing"]')) return;

    var plan = document.getElementById('spc-plan');
    var revenue = document.getElementById('spc-revenue');
    var aov = document.getElementById('spc-aov');
    var custom = customField();

    // The custom-revenue field is optional: it used to be required here, so an article
    // without it left the whole widget unwired rather than merely lacking that one input.
    if (!plan || !revenue || !aov) return;

    populateSelects(plan, revenue);

    plan.addEventListener('change', calculate);
    revenue.addEventListener('change', onRevenueChange);
    aov.addEventListener('input', calculate);
    if (custom) custom.addEventListener('input', calculate);

    calculate();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
